import ChoosePassword from './choosePassword'
export default ChoosePassword
